import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, CreateEffectMetadata, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, EMPTY } from 'rxjs';

import { UserService } from '../../../services/user.service';
import { fetchAdminAlerts, hideAdminAlert, setAdminAlertsItems } from './actions';

@Injectable()
export class AdminAlertsEffects {
  private actions$ = inject(Actions);
  private userService = inject(UserService);

  fetchAlerts$: CreateEffectMetadata = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAdminAlerts),
      switchMap(() =>
        this.userService.getAdminAlerts().pipe(
          map((alerts) => setAdminAlertsItems({ payload: alerts })),
          catchError(() => EMPTY),
        ),
      ),
    ),
  );

  hideAlert$: CreateEffectMetadata = createEffect(() =>
    this.actions$.pipe(
      ofType(hideAdminAlert),
      switchMap((action) =>
        this.userService.getAdminAlerts().pipe(
          map((alerts) => setAdminAlertsItems({ payload: alerts.filter((alert) => alert.id !== action.payload) })),
          catchError(() => EMPTY),
        ),
      ),
    ),
  );
}
